import { render, staticRenderFns } from "./recontentPhoneCase.vue?vue&type=template&id=d1736158&scoped=true&"
import script from "./recontentPhoneCase.vue?vue&type=script&lang=js&"
export * from "./recontentPhoneCase.vue?vue&type=script&lang=js&"
import style1 from "./recontentPhoneCase.vue?vue&type=style&index=1&id=d1736158&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1736158",
  null
  
)

export default component.exports